module.exports = __webpack_public_path__ + "img/equipment-cap-03.b948dee9.png";